var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacyOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pharmacy-outline_svg__clip0_770_10274)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.112 2.051a1.5 1.5 0 011.687 2.199L16.479 10h-3.464l4.186-7.25a1.5 1.5 0 01.91-.699zM11.268 12H21.95a9.993 9.993 0 01-5.403 7.9 1 1 0 00-.546.89V22H8v-1.21a1 1 0 00-.546-.89A9.991 9.991 0 012.05 12h9.218zm-.562-2l4.763-8.25a3.5 3.5 0 016.062 3.5L18.788 10H23a1 1 0 011 1 11.991 11.991 0 01-6 10.385V23a1 1 0 01-1 1H7a1 1 0 01-1-1v-1.615A11.991 11.991 0 010 11a1 1 0 011-1h9.706zM12 13a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2H9a1 1 0 110-2h2v-2a1 1 0 011-1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pharmacy-outline_svg__clip0_770_10274"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgPharmacyOutline;